import Bell from '@assets/images/common/icon/header/bell.svg';
import BellFull from '@assets/images/common/icon/header/bell-full.svg';
import BellGrayFull from '@assets/images/common/icon/header/bell-gray-full.svg';

import { BellProps } from './type';

export const BlackBell = ({
  handleToggle,
  notifications,
  isExistNewNotification = false,
}: BellProps) => {
  const bell = () => {
    if (isExistNewNotification) {
      return Bell;
    }
    return notifications.length > 0 ? BellFull : BellGrayFull;
  };

  return (
    <div className='flex size-[60px] items-center justify-center lg:mx-[-10px]'>
      <button
        type='button'
        onClick={handleToggle}
        className='relative'
        aria-label='通知'
      >
        {isExistNewNotification && (
          <div className='absolute right-0 top-0 size-[6px] rounded-full bg-warning-500'></div>
        )}
        <img
          className=''
          src={bell()}
          alt=''
          width='17'
          height='20'
        />
      </button>
    </div>
  );
};
